module.exports = __webpack_public_path__ + "media/eat7.345d9bf5.mp4";